var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.6666C16.891 21.6666 21.6666 16.891 21.6666 11C21.6666 5.10894 16.891 0.333313 11 0.333313C5.10894 0.333313 0.333313 5.10894 0.333313 11C0.333313 16.891 5.10894 21.6666 11 21.6666Z",
    fill: "#26A17B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2814 11.9222V11.9209C12.2081 11.9262 11.8301 11.9489 10.9867 11.9489C10.3134 11.9489 9.83939 11.9289 9.67272 11.9209V11.9229C7.08072 11.8089 5.14605 11.3575 5.14605 10.8175C5.14605 10.2782 7.08072 9.82687 9.67272 9.71087V11.4735C9.84205 11.4855 10.3274 11.5142 10.9981 11.5142C11.8027 11.5142 12.2061 11.4809 12.2814 11.4742V9.7122C14.8681 9.82754 16.7981 10.2789 16.7981 10.8175C16.7981 11.3575 14.8681 11.8075 12.2814 11.9222ZM12.2814 9.52887V7.95154H15.8907V5.5462H6.06339V7.95154H9.67272V9.5282C6.73939 9.66287 4.53339 10.2442 4.53339 10.9402C4.53339 11.6362 6.73939 12.2169 9.67272 12.3522V17.4069H12.2814V12.3509C15.2101 12.2162 17.4107 11.6355 17.4107 10.9402C17.4107 10.2449 15.2101 9.6642 12.2814 9.52887Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.cb011f8605db71d4148b3e4af16f8839.svg";
export { ForwardRef as ReactComponent };